export default "__VITE_ASSET__C3G6GoVm__"